import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import { useState } from "react";

import { classNames } from "@/utils/classNames";

import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { useIsFeatureActiveUnauthenticated } from "@/utils/useIsFeatureActiveUnauthenticated";
import { useOnboardingRedirectPath } from "@/utils/useOnboardingVariant";

import { Loader } from "@/components/Loader/Loader";

import { NotificationPanel } from "@/pages/Private/pages/Notifications/components/NotificationPanel";
import { NotificationToast } from "@/pages/Private/pages/Notifications/components/NotificationToast";

import { OnboardingTour } from "@/components/FeatureOnboarding/OnboardingTour";
import { OnboardingTourHost } from "@/pages/Private/pages/OnboardingTour/OnboardingTourHost";

import { Sidebar } from "../Sidebar/Sidebar";
import { useTopbarInfo } from "../Topbar/useTopbarInfo";

export const DasboardLayout = () => {
	const initialUser = localStorage.getItem("initialUser");

	const [enabled, setEnabled] = useState<boolean>(false);

	const SELF_REGISTER = useIsFeatureActiveUnauthenticated(FeaturesCodes.SELF_REGISTER);

	// Which onboarding still owes this user, derived once server-side (PREC-3719).
	const onboardingRedirect = useOnboardingRedirectPath();

	if (SELF_REGISTER === undefined) {
		return <Loader />;
	}

	if (onboardingRedirect) {
		return <Navigate to={onboardingRedirect} />;
	}

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "100vh",
			}}
		>
			<>
				<div
					className={classNames(
						"w-full flex flex-row h-[100vh]",
						initialUser ? "bg-other-org" : "bg-brand-white"
					)}
				>
					<Sidebar />
					<div className="sm:z-10 flex-grow min-w-0 h-full relative">
						<div
							className={classNames(
								"bg-white px-4 py-0 overflow-y-visible overflow-x-auto lg:overflow-auto",
								"h-[calc(100%-1rem)] max-h-[calc(100vh-1rem)]"
							)}
							id="outlet-container"
							style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
						>
							<Outlet />
						</div>
					</div>
				</div>
				<NotificationPanel />
				<NotificationToast />
				<OnboardingTour />
				<OnboardingTourHost />
			</>
		</Box>
	);
};
